import type { Price } from '@/types/paymentPlans'

export interface BaseApiPlan {
  id: number
  interval: 'DAILY' | 'WEEKLY' | 'MONTHLY' | 'YEARLY'
  tier: string
  prices: Price[]
  type: string
  has_access_to_rake_ai: boolean
  provider: 'Stripe' | 'Adyen' | 'Confirmo' | 'Paypal' | 'Gtowizard'
}

interface AdyenApiPlan extends Omit<BaseApiPlan, 'prices'> {
  price: Price
  provider: 'Adyen'
}

export type ApiPlan = AdyenApiPlan | BaseApiPlan

export const isAdyenApiPlan = (plan: ApiPlan): plan is AdyenApiPlan => 'price' in plan
